<template lang="pug">
  nav.b-menu-left(:class="{ opened }")
    ul._list.list-reset
      li._item(
      v-for="item in items"
      :key="item.label"
      )
        router-link._link(:to="{ name: item.route }" :class="item.route")
          ._count(v-if="item.label === 'Контакты' && contactRequestQty > 0") {{ contactRequestQty }}
          Icon(:name="item.icon" pointer)
          | {{ item.label }}
</template>

<script>
export default {
  name: 'MenuLeft',
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: [
        /* eslint-disable no-multi-spaces */
        { label: 'Главная',     icon: 'home',           route: 'home'           },
        { label: 'Проекты',     icon: 'project',        route: 'project-list'   },
        // { label: 'Календарь',   icon: 'calendar',       route: 'calendar'       },
        { label: 'Тарифы',      icon: 'tariffs',        route: 'tariffs'        },
        { label: 'Контакты',    icon: 'members',        route: 'contacts'       },
        { label: 'Аккаунт',     icon: 'account',        route: 'account'        },
        { label: 'уведомления', icon: 'notifications2', route: 'notifications'  },
        { label: 'Диаграмма',   icon: 'gantt',          route: 'gantt'  },
        { label: 'Задачи',      icon: 'tasks',          route: 'my-task-list'  },
        /* eslint-enable */
      ],
    };
  },
  computed: {
    self() { return this.$store.state.auth.user; },
    contactRequestQty() {
      return this.$store.state.contact.items
        .filter(c => c.isRequest && this.self.id === c.acceptor.id).length;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../assets/styles/helpers/functions";
.menu-left {
  position: absolute;
  top: calc(20vh - 50px);
  left: calc(10vw - 128px);
  color: var(--color-violent-gray);
  &__list {
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(2, 1fr);
  }
  &__link {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-transform: uppercase;
    border-radius: 6px;
    font-size: 11px;
    padding: 19px;
    transition: background-color 0.3s, color 0.3s;
    position: relative;
    svg {
      display: block;
      width: 32px;
      height: 32px;
      margin-bottom: 10px;
      fill: var(--color-violent-gray);
      transition: fill 0.3s;
    }
    &:hover {
      color: var(--color-white);
      background-color: var(--color-accent);
      svg {
        fill: var(--color-white);
      }
    }
    &.router-link-exact-active.home, &.router-link-active:not(.home) {
      color: var(--color-white) !important;
      background-color: var(--color-accent);
      svg {
        fill: var(--color-white);
      }
    }
  }

  &__count {
    position: absolute;
    font-size: 12px;
    line-height: 15px;
    color: #FFFFFF;
    background: #F17275;
    min-width: 7px;
    border-radius: 12px;
    padding: 0 4px;
    top: 50%;
    left: 50%;
    text-align: center;
    margin-top: -10px;
  }

  @media (max-width: 1700px) {
    position: relative;
    grid-column: 2 span;
    left: 0;
    top: 30px;
    &__list {
      grid-template-columns: 1fr;
      gap: 16px;
    }
    &__link {
      padding: 25px;
      font-size: 10px;
      svg {
        width: 29px;
        height: 29px;
      }
    }
  }

  @media (max-width: 1500px) {
    top: 0;
    padding: 30px 0 64px;
    grid-column: auto;

    &__list {
      grid-template-columns: 1fr;
      gap: 16px;
    }

    &__link {
      padding: 14px 5px;
      font-size: 9px;
    }
  }

  @media (max-width: 1024px) {
    display: grid;
    place-items: center;
    position: absolute;
    top: 0;
    left: 0;
    overflow: auto;
    width: 90%;
    height: 100vh;
    z-index: 100;
    background-color: #F8F9FC;
    padding: 0;
    transform: translateX(-100%);
    transition: transform 0.4s;
    &__list {
      padding: 50px 0;
      grid-template-columns: repeat(2, 1fr);
      gap: 50px;
    }
    &__link {
      padding: 19px 14px;
      font-size: 16px;
    }
    &.opened {
      transform: translateX(0);
    }
    &-close {
      display: block;
    }
  }
}
</style>
